(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-information-content"] && !Shopify.designMode) return;
  try {
    (() => {
    const mobileMediaQuery = window.matchMedia('(max-width: 749px)');

    const updateSizeGuidePlacement = (sizeFieldset, sizeGuide, forceNewRow = false) => {
      const overflowList = sizeFieldset.querySelector('overflow-list');
      const sizeOptionCount = sizeFieldset.querySelectorAll(
        '.variant-option__button-label input[type="radio"]'
      ).length;
      const shouldForceWrap = mobileMediaQuery.matches && sizeOptionCount > 5;
      sizeFieldset.classList.remove('variant-option--size-guide-wrapped');
      sizeFieldset.classList.remove('variant-option--size-guide-forced-row');

      if (overflowList instanceof HTMLElement) {
        if (sizeGuide.parentElement !== overflowList) {
          overflowList.appendChild(sizeGuide);
        }

        if (forceNewRow) {
          sizeFieldset.classList.add('variant-option--size-guide-forced-row');
          if (sizeGuide.parentElement !== sizeFieldset) {
            sizeFieldset.appendChild(sizeGuide);
          }
          return;
        }

        if (!mobileMediaQuery.matches) {
          return;
        }

        const doesOverflow = overflowList.scrollWidth > overflowList.clientWidth + 1;
        if (!doesOverflow && !shouldForceWrap) {
          return;
        }

        sizeFieldset.classList.add('variant-option--size-guide-wrapped');
        if (sizeGuide.parentElement !== sizeFieldset) {
          sizeFieldset.appendChild(sizeGuide);
        }
        return;
      }

      if (sizeGuide.parentElement !== sizeFieldset) {
        sizeFieldset.appendChild(sizeGuide);
      }

      if (forceNewRow) {
        sizeFieldset.classList.add('variant-option--size-guide-forced-row');
        return;
      }

      if (!mobileMediaQuery.matches) {
        return;
      }

      const doesOverflow = sizeFieldset.scrollWidth > sizeFieldset.clientWidth + 1;
      if (doesOverflow || shouldForceWrap) {
        sizeFieldset.classList.add('variant-option--size-guide-wrapped');
      }
    };

    const applyMileoffSizeRowLayout = (root = document) => {
      const scopes = root.querySelectorAll('.product-information--mileoff .product-details');
      scopes.forEach((details) => {
        const productInformation = details.closest('.product-information--mileoff');
        const forceSizeGuideNewRow = productInformation?.dataset.mileoffForceSizeGuideNewRow === 'true';
        const variantPickerForm = details.querySelector('.variant-picker__form');
        const sizeGuide = details.querySelector('.pdp-size-guide');
        if (!variantPickerForm || !sizeGuide) return;
        const sizeGuidePlacement = sizeGuide.dataset.sizeGuidePlacement || 'inline_with_swatches';
        const swatchesBlock = details.querySelector('product-swatches');

        if (swatchesBlock instanceof HTMLElement) {
          swatchesBlock.classList.remove('product-swatches--with-size-guide');
        }

        const fieldsets = Array.from(variantPickerForm.querySelectorAll('.variant-option--buttons'));
        if (!fieldsets.length) return;

        const sizeFieldset =
          fieldsets.find((fieldset) => {
            const legendText = fieldset.querySelector('legend')?.textContent?.trim().toLowerCase() || '';
            return legendText.includes('size');
          }) || fieldsets[fieldsets.length - 1];

        if (!sizeFieldset) return;

        sizeFieldset.classList.add('variant-option--size');
        sizeFieldset.classList.remove('variant-option--size-guide-wrapped');
        sizeFieldset.classList.remove('variant-option--size-guide-forced-row');

        if (sizeGuidePlacement == 'inline_with_size') {
          updateSizeGuidePlacement(sizeFieldset, sizeGuide, forceSizeGuideNewRow);
          return;
        }

        if (sizeGuidePlacement == 'inline_with_swatches' && swatchesBlock instanceof HTMLElement) {
          swatchesBlock.classList.add('product-swatches--with-size-guide');
          if (sizeGuide.parentElement !== swatchesBlock) {
            swatchesBlock.appendChild(sizeGuide);
          }
          return;
        }

        const placementAnchor = swatchesBlock instanceof HTMLElement ? swatchesBlock : sizeFieldset;
        if (!(placementAnchor instanceof HTMLElement) || !(placementAnchor.parentElement instanceof HTMLElement)) {
          updateSizeGuidePlacement(sizeFieldset, sizeGuide, forceSizeGuideNewRow);
          return;
        }

        if (sizeGuidePlacement == 'above_right') {
          placementAnchor.parentElement.insertBefore(sizeGuide, placementAnchor);
          return;
        }

        if (sizeGuidePlacement == 'below_right') {
          placementAnchor.parentElement.insertBefore(sizeGuide, placementAnchor.nextSibling);
          return;
        }

        updateSizeGuidePlacement(sizeFieldset, sizeGuide, forceSizeGuideNewRow);
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => applyMileoffSizeRowLayout(), { once: true });
    } else {
      applyMileoffSizeRowLayout();
    }

    document.addEventListener('shopify:section:load', (event) => applyMileoffSizeRowLayout(event.target));

    let resizeRaf;
    window.addEventListener(
      'resize',
      () => {
        cancelAnimationFrame(resizeRaf);
        resizeRaf = requestAnimationFrame(() => applyMileoffSizeRowLayout());
      },
      { passive: true }
    );

    // Re-run once async blocks are mounted (e.g. app/theme block hydration timing).
    setTimeout(() => applyMileoffSizeRowLayout(), 200);
    setTimeout(() => applyMileoffSizeRowLayout(), 800);
  })();
  } catch(e) { console.error(e); }
})();

})();
